//client/src/pages/user/Settings.js
import { useState } from "react";
import api from "../../api/axiosInstance";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-hot-toast";

export default function Settings() {
  const { authUser, setAuthUser } = useAuth();

  const [avatarPreview, setAvatarPreview] = useState(authUser?.user?.avatar);
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");

  /* ================= AVATAR ================= */
  const handleAvatarUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setAvatarPreview(URL.createObjectURL(file));

    const form = new FormData();
    form.append("avatar", file);

    try {
      const { data } = await api.post("/user/avatar", form);
      setAuthUser((prev) => ({
        ...prev,
        user: { ...prev.user, avatar: data.avatar },
      }));
      toast.success("Avatar updated");
    } catch {
      toast.error("Avatar upload failed");
    }
  };

  /* ================= PASSWORD ================= */
  const changePassword = async () => {
    if (!oldPass || !newPass)
      return toast.error("Both fields required");

    try {
      await api.put("/user/change-password", {
        oldPassword: oldPass,
        newPassword: newPass,
      });
      toast.success("Password updated");
      setOldPass("");
      setNewPass("");
    } catch (e) {
      toast.error(e.response?.data?.message || "Failed");
    }
  };

  /* ================= EMAIL ================= */
  const updateEmail = async () => {
    if (!email) return toast.error("Enter new email");

    try {
      await api.put("/user/change-email", { email });
      toast.success("Verification sent to new email");
      setEmail("");
    } catch {
      toast.error("Email update failed");
    }
  };

  return (
    <div className="space-y-10">
      <h1 className="text-2xl font-bold">Profile Settings</h1>

      {/* AVATAR */}
      <div className="card-glass p-6 space-y-4 max-w-md">
        <div className="flex items-center gap-4">
          <div className="w-20 h-20 rounded-full overflow-hidden bg-purple-600">
            {avatarPreview ? (
              <img src={avatarPreview} alt="avatar" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-white text-xl font-bold">
                {authUser?.user?.name?.charAt(0)}
              </div>
            )}
          </div>

          <label className="btn-primary cursor-pointer">
            Change Avatar
            <input type="file" hidden accept="image/*" onChange={handleAvatarUpload} />
          </label>
        </div>

        <input className="input-glass" value={authUser?.user?.name} disabled />
        <input className="input-glass" value={authUser?.user?.email} disabled />
      </div>

      {/* PASSWORD */}
      <div className="card-glass p-6 space-y-4 max-w-md">
        <h2 className="font-semibold">Change Password</h2>

        <input
          type={showPassword ? "text" : "password"}
          className="input-glass"
          placeholder="Old password"
          value={oldPass}
          onChange={(e) => setOldPass(e.target.value)}
        />

        <input
          type={showPassword ? "text" : "password"}
          className="input-glass"
          placeholder="New password"
          value={newPass}
          onChange={(e) => setNewPass(e.target.value)}
        />

        <div className="flex justify-between items-center">
          <button
            onClick={() => setShowPassword(!showPassword)}
            className="text-sm text-purple-400 underline"
          >
            {showPassword ? "Hide password" : "Show password"}
          </button>

          <button onClick={changePassword} className="btn-primary">
            Update Password
          </button>
        </div>
      </div>

      {/* EMAIL */}
      <div className="card-glass p-6 space-y-4 max-w-md">
        <h2 className="font-semibold">Update Email</h2>

        <input
          type="email"
          className="input-glass"
          placeholder="New email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button onClick={updateEmail} className="btn-primary">
          Update Email
        </button>

        <p className="text-xs text-gray-400">
          Verification email will be sent to the new address.
        </p>
      </div>
    </div>
  );
}
